import { Injectable } from '@angular/core';
import { Select } from '@ngxs/store';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Observable, of } from 'rxjs';

import { Score } from '@sc/data-access-models';

import {
  ScoresClearedAction,
  ScoresState,
  ScoresAddedAction,
} from '../../store';

@Injectable({
  providedIn: 'root',
})
export class ScoresSandboxService {
  @Select(ScoresState)
  public scores$: Observable<Score[]>;

  @Dispatch()
  public updateScores(scores: Score[]): Observable<ScoresAddedAction> {
    return of(new ScoresAddedAction(scores));
  }

  @Dispatch()
  public clearScores(): Observable<ScoresClearedAction> {
    return of(new ScoresClearedAction());
  }
}
